import { render, staticRenderFns } from "./indexSingleFile.vue?vue&type=template&id=52b3df06&scoped=true&"
import script from "./indexSingleFile.vue?vue&type=script&lang=js&"
export * from "./indexSingleFile.vue?vue&type=script&lang=js&"
import style0 from "./indexSingleFile.vue?vue&type=style&index=0&id=52b3df06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3df06",
  null
  
)

export default component.exports